module.exports = __webpack_public_path__ + "h5/img/red-packet.7b5ff4ca.png";